import styled from 'styled-components'

import { Box, Sun, Text } from '@redriverpress/system'

const DemoBox = styled(Box).attrs(() => ({
  border: '1px solid',
  borderColor: 'gray600',
  borderRadius: 'rounded',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  size: '3rem',
  role: 'img',
}))``

export function DemoImage(props) {
  return (
    <DemoBox {...props}>
      <Sun size='2rem' />
    </DemoBox>
  )
}

export function DemoImageText(props) {
  return (
    <DemoBox {...props}>
      <Sun size='1.5rem' />
      <Text fontSize='8px' fontWeight='700'>
        sun
      </Text>
    </DemoBox>
  )
}

export function DemoText(props) {
  return (
    <DemoBox {...props}>
      <Text fontWeight='800'>sun</Text>
    </DemoBox>
  )
}

export function DemoOpenSans(props) {
  return (
    <DemoBox {...props}>
      <Text fontWeight='800' fontSize={2}>
        abc
      </Text>
    </DemoBox>
  )
}

export function DemoQuicksand(props) {
  return (
    <DemoBox {...props}>
      <Text font='literacy' fontWeight='700' fontSize={2}>
        abc
      </Text>
    </DemoBox>
  )
}
